import style from './Navbar.module.css'
import {Col, Row} from "react-bootstrap";
import {IoChevronBack, IoChevronForward} from "react-icons/io5";
import {IoIosClose} from "react-icons/io";
import {useTranslation} from "react-i18next";
import {Skeleton} from "@mui/material";
import {useNavigate} from "react-router";
import i18n from "i18next";
import { CloseObject } from '../../models/closeObject';
import Swal from "sweetalert2";

export interface Props {
    title: string;
    subTitle: string;
    loading: boolean;
    cancel?: boolean;
    referral_url?: string;
    closeObject?: CloseObject;
    noDottedLine?: boolean;
}

const Navbar = (props: Props) => {
    let navigate = useNavigate();
    const {t} = useTranslation()
    const { closeObject, noDottedLine } = props;
    const onClickBackHandler=()=>{
        if(closeObject){
            Swal.fire({
            icon: "warning",
            html: `<div class="pe-10 ps-10 fw-bolder"><h3>${closeObject.confirmation?.title ?? ""}</h3><p>${closeObject.confirmation?.subtitle ?? ""}</p></div>`,
            buttonsStyling: false,
            showCancelButton: true,
            cancelButtonText: t("navbar.close.popup.no"),
            showLoaderOnConfirm: true,
            confirmButtonText: t("navbar.close.popup.yes"),
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-light-danger",
            },
            allowOutsideClick: () => !Swal.isLoading(),
            }).then((result) => {
            if (result.isConfirmed) {
                setTimeout(() => {
                    if (props.referral_url) {
                      window.location.href = props.referral_url;
                      return;
                    }
                }, 1000);
            }
            });
            return;
        }


        if (props.referral_url){
            window.location.href = props.referral_url
            return
        }
        navigate(-1)
    }




    return (
        <div dir={i18n.language=='en'?'ltr':'rtl'} className={`${style.container}`}>
            <header className={style.navbar_container}>
                {props.loading ? <div
                                    style={{
                                        width: "24px",
                                        height: "24px",
                                        borderRadius: "50%",
                                        background: "#e0e0e0",
                                        animation: "pulse 1.5s infinite ease-in-out"
                                    }}
                                    />: 
                (props.cancel || closeObject) ? <IoIosClose onClick={onClickBackHandler}></IoIosClose> :
                    i18n.language=='en'?<IoChevronBack onClick={() => onClickBackHandler()} />:
                    <IoChevronForward onClick={() => onClickBackHandler()}></IoChevronForward>
                }
                {/*<div className={`${style.navbar_help} ${style.cursor}`} onClick={(event) => {*/}
                {/*    window.location.href=`https://jo.opensooq.com/${i18n.language}/support`*/}

                {/*}}>*/}
                {/*    {t('navbar.help')}*/}
                {/*</div>*/}
            </header>
            <Row>
                <Col>
                    {
                        <span className={'basic_height'}><b className={'md_text'}>{props.title}</b>
                        <p className={'grey_text'}>{props.loading ?
                            <Skeleton width={"130px"}/> : props.subTitle}</p></span>}
                </Col>
                {!noDottedLine && <div className={`${style.dotted_line} py-1 mt-2 mb-3`} />}
            </Row>
        </div>
    )
}

export default Navbar